module.exports = "<select\r\n    class=\"w3-select w3-block w3-border w3-round\"\r\n    [(ngModel)]=\"value\"\r\n    [disabled]=\"isDisabled\">\r\n    <option [value]=\"null\">Select vehicle</option>\r\n    <option *ngFor=\"let v of vehicles\" [value]=\"v.key\">{{v.value}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-vehicle-select/ztsi-vehicle-select.component.html
// module id = ./src/app/components/shared/ztsi-vehicle-select/ztsi-vehicle-select.component.html
// module chunks = main